module.exports = __webpack_public_path__ + "static/media/locate.bf0b4d6e.svg";